<template>
  <v-layout row>
    <v-flex xs12 md6>
      <v-layout
        ><v-flex xs12 class="form-subtitle paid-title"
          >ご住所<span class="attention">（必須）</span></v-flex
        ></v-layout
      >
      <v-layout v-if="showSection">
        <v-flex xs12>
          <v-select
            v-model="country"
            :items="formattedCountries"
            item-text="label"
            item-value="value"
            label="国*"
            :error-messages="errorCountry"
          >
            <template v-slot:selection="{ item }">
              {{ getFlagEmoji(item.value) }} {{ item.label }}
            </template>
            <template v-slot:item="{ item }">
              {{ getFlagEmoji(item.value) }} {{ item.label }}
            </template>
          </v-select>
          <input type="hidden" name="country" v-model="country" />
        </v-flex>
      </v-layout>

      <v-layout row v-if="computedLocale === 'ja'">
        <!-- 日本語ユーザー向け: 郵便番号入力（2フォーム） -->
        <v-flex xs3 class="col-tel">
          <v-text-field
            v-model="zip1_1"
            name="zip1_1"
            type="text"
            pattern="^[0-9]+$"
            class="zip1"
            maxlength="3"
            :error-messages="errorZip1_1"
            v-bind:class="{ zerror: zipError }"
          ></v-text-field>
          <v-flex>
            <span class="tel-hyphen">-</span>
          </v-flex>
        </v-flex>
        <v-flex xs4 class="col-tel">
          <v-text-field
            v-model="zip1_2"
            name="zip1_2"
            type="text"
            pattern="^[0-9]+$"
            class="zip2"
            maxlength="4"
            :error-messages="errorZip1_2"
            v-bind:class="{ zerror: zipError }"
          ></v-text-field>
        </v-flex>
        <v-flex xs5>
          <v-btn :loading="zipLoading" @click="searchAddr">住所検索</v-btn>
        </v-flex>
      </v-layout>

      <v-layout row v-if="computedLocale === 'en'">
        <!-- 英語ユーザー向け: 郵便番号入力（1フォーム）  -->
        <v-flex xs12>
          <v-text-field
            v-model="zip_code"
            name="zip_code"
            type="text"
            pattern="^\d{5}(-\d{4})?$"
            class="zip"
            maxlength="10"
            :label="'ZIP Code*'"
            :error-messages="errorZip"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row v-if="zipError && computedLocale === 'ja'">
        <v-flex xs12>
          <p class="zip-error-text error--text">
            該当する住所が検索されません。
          </p>
        </v-flex>
      </v-layout>

      <v-layout row v-if="computedLocale === 'ja'">
        <v-flex xs12>
          <v-select
            v-model="prefecture"
            :items="prefectures"
            item-text="label"
            item-value="value"
            label="都道府県*"
            :error-messages="errorPrefecture"
          >
          </v-select>
          <input type="hidden" name="prefecture" v-model="prefecture" />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex xs12>
          <v-text-field
            v-model="addr1"
            name="addr1"
            type="text"
            :label="
              computedLocale === 'ja' ? '市区町村番地*' : 'Address Line 1*'
            "
            class="addr1"
            :error-messages="errorAddr1"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex xs12>
          <v-text-field
            v-model="addr2"
            name="addr2"
            type="text"
            :label="
              computedLocale === 'ja' ? 'マンション・ビル名' : 'Address Line 2'
            "
            :error-messages="errorAddr2"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  props: {
    locale: {
      type: String,
      default: "ja",
    },
    defaultCountry: String,
    countries: Object,
    defaultZip1_1: String,
    defaultZip1_2: String,
    defaultZipCode: String,
    prefectures: Array,
    defaultPrefecture: [String, Number],
    defaultAddr1: String,
    defaultAddr2: String,
    errorZip1_1: String,
    errorZip1_2: String,
    errorZip: String,
    errorPrefecture: String,
    errorAddr1: String,
    errorAddr2: String,
    errorCountry: String,

    showSection: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      country: this.defaultCountry,
      zip1_1: this.defaultZip1_1,
      zip1_2: this.defaultZip1_2,
      zip_code: this.defaultZipCode || "",
      prefecture: parseInt(this.defaultPrefecture),
      addr1: this.defaultAddr1,
      addr2: this.defaultAddr2,
      zipLoading: false,
      zipError: false,
    };
  },

  computed: {
    formattedCountries() {
      return Object.entries(this.countries).map(([key, value]) => ({
        value: key,
        label: value,
      }));
    },
    computedLocale() {
      return this.locale || "ja";
    },
  },

  methods: {
    searchAddr() {
      if (this.locale === "en") return;

      this.zipLoading = true;

      axios
        .get("/zip_addr", {
          params: {
            zipcode: this.zip1_1 + this.zip1_2,
          },
        })
        .then((res) => {
          const data = JSON.parse(res.data);

          if (res.status !== 200 || !data || data.results.length < 1) {
            return false;
          }

          this.prefecture = parseInt(data.results[0].prefcode);
          this.addr1 = data.results[0].address2 + data.results[0].address3;

          this.zipLoading = false;
          this.zipError = false;
        })
        .catch((res) => {
          console.log(res);
          this.zipLoading = false;
          this.zipError = true;
        });
    },

    getFlagEmoji(countryCode) {
      return countryCode
        .toUpperCase()
        .split("")
        .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
        .join("");
    },
  },
};
</script>

<style lang="scss">
.attention {
  color: #e3342f;
  font-size: 1rem;
}
input[type="number"] {
  -moz-appearance: textfield;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.zip-error-text {
  margin-top: -10px;
  font-size: 1.05rem;
}

.zerror > .v-input__control > .v-input__slot:before {
  border-color: #ff5252 !important;
}
</style>
